import _ from 'lodash';
import { history } from '../history';
import { getSoloConnectEligiblePlans } from './soloConnectPlans';

export const getPlans = (plans) => {
  const {
    location: { pathname, state },
  } = history;

  let serviceType = pathname.split('/')[4];

  let selplans;
  if (state && state.kc && state.scnumber) {
    if (serviceType === 'soloconnect') {
      selplans = getSoloConnectEligiblePlans(plans, state.kc, state.region);
    } else {
      selplans = plans.filter(
        (plan) =>
          plan.metadata.service_type === serviceType &&
          plan.metadata.modem === state.kc,
      );
    }
    return { plan1: _.orderBy(selplans, ['interval'], ['asc']) };
  }

  selplans = plans.filter((plan) => plan.metadata.service_type === serviceType);

  return { plan1: _.orderBy(selplans, ['interval'], ['asc']) };
};
